import React from 'react';
import IncentiveCard from './IncentiveCard';
import { 
  MegaphoneIcon, 
  UsersIcon, 
  BuildingOfficeIcon,
  DocumentTextIcon,
  ChatBubbleBottomCenterTextIcon,
  RocketLaunchIcon
} from '@heroicons/react/24/outline';

const SponsorIncentives: React.FC = () => {
  const incentives = [
    {
      title: 'Premium Brand Visibility',
      description: 'Showcase your brand at the Austrian Parliament and gain exposure to a targeted audience of language technology professionals.',
      icon: <MegaphoneIcon className="w-8 h-8" />
    },
    {
      title: 'Direct Access to Decision Makers',
      description: 'Connect with C-level executives, researchers, and practitioners in the language technology industry.',
      icon: <UsersIcon className="w-8 h-8" />
    },
    {
      title: 'Prestigious Venue',
      description: 'Associate your brand with one of Europe\'s most prestigious venues, enhancing your company\'s reputation.',
      icon: <BuildingOfficeIcon className="w-8 h-8" />
    },
    {
      title: 'Content Marketing',
      description: 'Featured in our conference materials, website, and social media channels reaching thousands of professionals.',
      icon: <DocumentTextIcon className="w-8 h-8" />
    },
    {
      title: 'Speaking Opportunities',
      description: 'Present your solutions and share your expertise through dedicated speaking slots.',
      icon: <ChatBubbleBottomCenterTextIcon className="w-8 h-8" />
    },
    {
      title: 'Innovation Showcase',
      description: 'Demonstrate your latest products and innovations to a highly engaged audience.',
      icon: <RocketLaunchIcon className="w-8 h-8" />
    }
  ];

  return (
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
        Why Sponsor Language Intelligence 2025?
      </h2>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {incentives.map((incentive, index) => (
          <IncentiveCard
            key={index}
            title={incentive.title}
            description={incentive.description}
            icon={incentive.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default SponsorIncentives;
